<div class="shopify-sync">
  <mat-form-field appearance="outline" color="primary" class="formField">
    <mat-label>Shopify Domain</mat-label>
    <input [formControl]="shopifyFormControl" type="text" matInput />
    @if (organization.lastSyncedAt != null) {
      <mat-hint>Last Synced on {{ organization.lastSyncedAt }}</mat-hint>
    }
    <button
      mat-icon-button
      matSuffix
      (click)="shopifyLogin()"
      [disabled]="shopifyFormControl.untouched"
    >
      <mat-icon>sync</mat-icon>
    </button>
  </mat-form-field>

  @if (requestInProgress) {
    <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  }

  <div class="actions">
    <button
      (click)="saveShopifyDomain()"
      color="buttonSuccess"
      [disabled]="!shopifyFormControl.valid || requestInProgress"
      mat-button
    >
      Save
    </button>
  </div>
</div>
